import Vue from "vue";
import Vuex from "vuex";

import timer from "./modules/timer";
import account from "./modules/account";
import latestActivity from "./modules/latestActivity";
import projects from "./modules/projects";
import users from "./modules/users";
import credentials from "./modules/credentials";
import darkMode from "./modules/darkMode";
import tags from "./modules/tags";
import notes from "./modules/notes";
import tasks from "./modules/tasks";
import filter from "./modules/filter";
import clients from "./modules/clients";
import statuses from "./modules/statuses";
import userType from "./modules/userType";
import calendar from "./modules/calendar";
import stats from './modules/stats';
import activity from "./modules/activity";

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		timer,
		account,
		latestActivity,
		projects,
		users,
		credentials,
		darkMode,
		tags,
		notes,
		tasks,
		filter,
		clients,
		statuses,
		userType,
		calendar,
		stats,
		activity
	},

	state: {
		refCount: 0,
		isLoading: false
	},

	mutations: {
		loading(state, isLoading) {
			console.log("loading payload =", isLoading);
			if (isLoading) {
				state.refCount++;
				state.isLoading = true;
			} else if (state.refCount > 0) {
				state.refCount--;
				state.isLoading = state.refCount > 0;
			}
		}
	}
});
